import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  Provider,
  useStateContext,
  ChatContainer,
  NimKitCoreFactory,
  useTranslation,
} from "@xkit-yx/im-kit-ui";
import general, { redux } from "../../../../general";
import Dialog from "../../../../lib/Dialog";
import { Link } from "react-router-dom";
import { createFromIconfontCN, RightOutlined } from "@ant-design/icons";
import reactStringReplace from "react-string-replace";
import { CSSTransition } from "react-transition-group";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button, Popover, Modal } from "antd-mobile";
import OpenRedEnvelope from "./redEnvelope/OpenRedEnvelope";
import "@xkit-yx/im-kit-ui/es/style/css";
import "./css/Chat.css";
import RedEnvelopeAlert from "./redEnvelope/RedEnvelopeAlert";
import { useEnvelopeStatuses } from "./redEnvelope/useEnvelopeStatuses";
import Manager from "../../../components/Manager";

let members = [];
let nickMembers = [];
let unInChatInfo = {};

export default function IMChat(props) {
  const { t } = useTranslation();
  const { store, nim } = useStateContext();
  const [title, setTitle] = useState();
  const [announcement, setAnnouncement] = useState(null);
  const [pack_serialcode, set_pack_serialcode] = useState("");
  const [alert, setAlert] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [gameid, setGameid] = useState();
  const [nickname, setNickname] = useState({});
  const [is_display_honor, set_is_display_honor] = useState(false);
  const { envelopeStatuses, updateEnvelopeStatus } = useEnvelopeStatuses();
  const [visible, setVisible] = useState(false);
  const [redenvelopeTopMsg, setRedenvelopeTopMsg] = useState();

  const outAction = [
    { key: "recall", text: "撤回" },
    { key: "delete", text: "删除" },
    { key: "copy", text: "复制" },
  ];
  const inAction = [
    { key: "reply", text: "回复" },
    { key: "delete", text: "删除" },
    { key: "copy", text: "复制" },
  ];

  const appointInAction = [
    { key: "reply", text: "回复" },
    { key: "delete", text: "删除" },
    { key: "copy", text: "复制" },
    { key: "appoint", text: "撤回" },
  ];

  const renderTeamInputPlaceHolder = (options) => {
    return "和大家说点什么吧";
  };

  const handleEmojiTranslate = (t) => {
    const EMOJI_ICON_MAP_CONFIG = {
      [t("Laugh")]: "icon-a-1",
      [t("Happy")]: "icon-a-2",
      [t("Sexy")]: "icon-a-3",
      [t("Cool")]: "icon-a-4",
      [t("Mischievous")]: "icon-a-5",
      [t("Kiss")]: "icon-a-6",
      [t("Spit")]: "icon-a-7",
      [t("Squint")]: "icon-a-8",
      [t("Cute")]: "icon-a-9",
      [t("Grimace")]: "icon-a-10",
      [t("Snicker")]: "icon-a-11",
      [t("Joy")]: "icon-a-12",
      [t("Ecstasy")]: "icon-a-13",
      [t("Surprise")]: "icon-a-14",
      [t("Tears")]: "icon-a-15",
      [t("Sweat")]: "icon-a-16",
      [t("Angle")]: "icon-a-17",
      [t("Funny")]: "icon-a-18",
      [t("Awkward")]: "icon-a-19",
      [t("Thrill")]: "icon-a-20",
      [t("Cry")]: "icon-a-21",
      [t("Fretting")]: "icon-a-22",
      [t("Terrorist")]: "icon-a-23",
      [t("Halo")]: "icon-a-24",
      [t("Shame")]: "icon-a-25",
      [t("Sleep")]: "icon-a-26",
      [t("Tired")]: "icon-a-27",
      [t("Mask")]: "icon-a-28",
      [t("ok")]: "icon-a-29",
      [t("AllRight")]: "icon-a-30",
      [t("Despise")]: "icon-a-31",
      [t("Uncomfortable")]: "icon-a-32",
      [t("Disdain")]: "icon-a-33",
      [t("ill")]: "icon-a-34",
      [t("Mad")]: "icon-a-35",
      [t("Ghost")]: "icon-a-36",
      [t("Angry")]: "icon-a-37",
      [t("Angry")]: "icon-a-38",
      [t("Unhappy")]: "icon-a-39",
      [t("Frown")]: "icon-a-40",
      [t("Broken")]: "icon-a-41",
      [t("Beckoning")]: "icon-a-42",
      [t("Ok")]: "icon-a-43",
      [t("Low")]: "icon-a-44",
      [t("Nice")]: "icon-a-45",
      [t("Applause")]: "icon-a-46",
      [t("GoodJob")]: "icon-a-47",
      [t("Hit")]: "icon-a-48",
      [t("Please")]: "icon-a-49",
      [t("Bye")]: "icon-a-50",
      [t("First")]: "icon-a-51",
      [t("Fist")]: "icon-a-52",
      [t("GiveMeFive")]: "icon-a-53",
      [t("Knife")]: "icon-a-54",
      [t("Hi")]: "icon-a-55",
      [t("No")]: "icon-a-56",
      [t("Hold")]: "icon-a-57",
      [t("Think")]: "icon-a-58",
      [t("Pig")]: "icon-a-59",
      [t("NoListen")]: "icon-a-60",
      [t("NoLook")]: "icon-a-61",
      [t("NoWords")]: "icon-a-62",
      [t("Monkey")]: "icon-a-63",
      [t("Bomb")]: "icon-a-64",
      [t("Sleep")]: "icon-a-65",
      [t("Cloud")]: "icon-a-66",
      [t("Rocket")]: "icon-a-67",
      [t("Ambulance")]: "icon-a-68",
      [t("Poop")]: "icon-a-70",
    };
    // TODO react-string-replace 的行为不是那么的好理解，比如像下面这个正则就一定要加 '()'，后面最好干掉自己实现
    const INPUT_EMOJI_SYMBOL_REG = new RegExp(
      "(" +
        Object.keys(EMOJI_ICON_MAP_CONFIG)
          .map((item) => {
            const left = `\\${item.slice(0, 1)}`;
            const right = `\\${item.slice(-1)}`;
            const mid = item.slice(1, -1);
            return `${left}${mid}${right}`;
          })
          .join("|") +
        ")",
      "g"
    );
    return {
      EMOJI_ICON_MAP_CONFIG,
      INPUT_EMOJI_SYMBOL_REG,
    };
  };

  const CommonIcon = createFromIconfontCN({
    scriptUrl: [
      "//yx-web-nosdn.netease.im/sdk-release/yunxun-imweb-iconfont.js",
      "//at.alicdn.com/t/c/font_3429868_blvaz7v7n6p.js",
    ], // 在 iconfont.cn 上生成
  });

  const onMessageAction = (action, msg) => {
    if (action.key === "recall") {
      store.msgStore.reCallMsgActive(msg);
    } else if (action.key === "delete") {
      store.msgStore.deleteMsgActive([msg]);
    } else if (action.key === "copy") {
      var textField = document.createElement("textarea");
      textField.innerText = msg.body;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
      Dialog.info("已复制到剪贴板");
    } else if (action.key === "reply") {
      store.msgStore.replyMsgActive(msg);
      const textarea = document.getElementsByClassName("ant-input")[0];
      textarea.focus();
      const text = "@" + msg.fromNick + " ";
      setTimeout(() => {
        textarea.setRangeText(text, 0, text.length - 1, "end");
      }, 300);
    } else if (action.key === "appoint") {
      general.axios.post("/base/yunxin/frontRecallMsg", {
        tid: props.query.tid,
        msgid: msg.idServer,
      });
    }
  };

  // 红包详情
  const getRedEnvelopeInfo = (redenvelope_id) => {
    Dialog.loading()
    return new Promise((resolve,reject)=>{
      general.axios.post('/getRedEnvelopeInfo',{
        redenvelope_id: redenvelope_id
      }).finally(()=>{
        Dialog.close()
      }).then(res=>{
        const {status,data} = res.data;
        if(status.succeed){
          if (data.is_exists) {
            updateEnvelopeStatus(data, true)
          }
          resolve(data)
        }else{
          Dialog.error(status.error_desc)
          reject()
        }
      })
    })
  }

  // 红包记录
  const handleRecord = (attach) => {
    Modal.clear();
    setTimeout(() => {
      general.history.push("/redEnvelopeRecord?id=" + attach.redenvelope_id);
    }, 400);
  };

  // 领取红包
  const handleOpen = (attach) => {
    console.log('attach',attach);
    
    Dialog.loading();
    general.axios
      .post("/grabClusterRedEnvelope", {
        redenvelope_id: attach.redenvelope_id,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        const { status, data } = res.data;
        if (status.succeed) {
          // 更新状态并持久化到 localStorage
          updateEnvelopeStatus(attach, true);
          handleRecord(attach)
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  // 打开红包弹窗
  const openRedEnvelopeAlert = (attach) => {
    Modal.show({
      content: (
        <OpenRedEnvelope
          destroyOnClose={true}
          attach={attach}
          handleOpen={attach => handleOpen(attach)}
          handleAction={attach => {
            Modal.clear()
            setTimeout(()=>{
              const task_type = parseInt(attach.task_condition.task_type)
              if (task_type == 1) {
                general.history.push("/game?id=" + attach.task_condition.game_id);
              } else if (task_type == 2) {
                general.history.push("/gameCommunity?topic_id=" + attach.task_condition.topic_id + "&circles_type=" + attach.task_condition.circles_type);
              }
            },300)
          }}
        ></OpenRedEnvelope>
      ),
      closeOnMaskClick: true,
      destroyOnClose: true,
      getContainer: document.getElementById("root"),
      bodyClassName: "red-envelpoe-modal",
      bodyStyle: {
        padding: 0,
        backgroundColor: "transparent",
      },
    });
  };

  const handleAction = (attach) => {
    Modal.clear();
    setTimeout(() => {
      getRedEnvelopeInfo(attach.redenvelope_id).then(data=>{
        if (data.is_pop_bullet) {
          openRedEnvelopeAlert(data);
        }else{
          handleRecord(data)
        }
      })
    }, 400);
  }

  const createTipDiv = (msg) => {
    const idDiv = document.getElementById(msg.idClient);
    if (idDiv) {
      // 1. 移除所有子元素
      while (idDiv.firstChild) {
        idDiv.removeChild(idDiv.firstChild);
      }

      if (typeof msg.body != "string" || !msg.body) {
        return;
      }
      try {
        // console.log('body=type',typeof(msg.body));
        // 1. 使用 trim() 移除字符串两端的空格
        const trimmedStr = msg.body.trim();
        // 2. 将所有单引号替换为双引号
        const jsonString = trimmedStr.replace(/'/g, '"');

        // 3. 使用 JSON.parse() 将字符串转换为对象
        const attach = JSON.parse(jsonString);

        // 2. 使用 document.createElement 创建所有需要的元素
        // 创建容器 div
        const container = document.createElement("div");
        // 设置容器样式
        container.style.display = "flex";
        container.style.alignItems = "center";
        container.style.padding = "12px";
        container.style.justifyContent = "center";

        // 创建 img 元素
        const img = document.createElement("img");
        img.src = "resources/251222/re_small.png"; // 示例图片路径
        img.alt = "";
        img.style.width = "15px";
        img.style.height = "20px";

        // 创建 span 元素
        const div = document.createElement("div");
        div.textContent = attach?.title;
        div.style.color = "#999";
        div.style.fontSize = "12px";
        div.style.paddingLeft = "5px";
        div.style.lineHeight = 1
        // 创建 红包 元素
        const redEnvelope = document.createElement("div");
        redEnvelope.addEventListener("click", (e) => {
          getRedEnvelopeInfo(attach?.redenvelope_id).then((data) => {
            if (data.is_pop_bullet) {
              openRedEnvelopeAlert(data);
            }else{
              general.history.push(`/redEnvelopeRecord?id=${data?.redenvelope_id}`);
            }
          })
        });
        redEnvelope.textContent = "红包";
        redEnvelope.style.color = "#FF3855";
        redEnvelope.style.fontSize = "12px";
        redEnvelope.style.lineHeight = 1

        // 3. 使用 appendChild 将元素组装起来
        container.appendChild(img);
        container.appendChild(div);
        container.appendChild(redEnvelope);

        // 4. 最后将组装好的容器添加到 idDiv 中
        idDiv.appendChild(container);
      } catch (error) {}
    }
  };

  const renderMessageOuterContent = (msg) => {
    const { body, idClient, ext, type, flow, custom, attach } = msg;
    // console.log("msg", msg.subType,msg);
    if (type == "tip") {
      return <div>{createTipDiv(msg)}</div>;
    } else if (type == "custom") {
      // 红包预约
      if (msg.subType == 6) {
        return (
          <div
            style={{
              width: "100%",
              border: "0.5px solid #DD342F",
              borderRadius: 8,
              padding: 13,
              borderTop: "5px solid #DD342F",
              backgroundColor: "white",
            }}
            onClick={() => {
              Manager.push({event_id:msg.attach?.event_id})
              getRedEnvelopeInfo(msg.attach.redenvelope_id).then(data=>{
                if (data.is_pop_bullet) {
                  openRedEnvelopeAlert(data);
                }else{
                  handleRecord(data)
                }
              })
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                paddingBottom: 12,
                flex: 1,
              }}
            >
              <img src="resources/251222/re_small.png" alt="" height={20} />
              <div
                style={{
                  color: "#DD342F",
                  fontSize: 14,
                  fontWeight: 500,
                  paddingLeft: 10,
                }}
              >
                红包预告
              </div>
            </div>
            <div style={{ color: "#282828", fontSize: 14, paddingBottom: 10 }}>
              {attach.preview_desc}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ color: "#999", fontSize: 12 }}>查看详情</div>
              <RightOutlined
                style={{ fontSize: 10, color: "#999" }}
              ></RightOutlined>
            </div>
          </div>
        );
      }
      // 红包
      else if (msg.subType == 7) {
        const isOpened = envelopeStatuses[attach.redenvelope_id]?.opened;
        return (
          <div
            style={{
              backgroundColor: isOpened ? "#EC7C78" : "#DD342F",
              borderRadius: 8,
              flex: 1,
            }}
            onClick={() => {
              Manager.push({event_id:attach?.event_id})
              getRedEnvelopeInfo(attach.redenvelope_id).then(data=>{
                if (data.is_pop_bullet) {
                  openRedEnvelopeAlert(data);
                }else{
                  updateEnvelopeStatus(data, true);
                  handleRecord(data)
                }
              })
            }}
          >
            <div style={{ padding: 13, display: "flex", alignItems: "center" }}>
              <img
                src={
                  "resources/251222/" +
                  (isOpened ? "re_receive" : "re_big") +
                  ".png"
                }
                alt=""
                height={44}
              />
              <div style={{ paddingLeft: 10 }}>
                <div
                  style={{ color: "#FFF7E3", fontSize: 16, fontWeight: 500 }}
                >
                  {attach.title}
                </div>
                <div style={{ color: "#FFF7E3", fontSize: 12, paddingTop: 1 }}>
                  查看详情
                </div>
              </div>
            </div>
            <div style={{ padding: "0 13px" }}>
              <div style={{ backgroundColor: "#FF8787", height: 0.5 }}></div>
            </div>
            <div style={{ padding: "5px 13px" }}>
              <div style={{ fontSize: 11, color: "#FFDEDE" }}>
                {attach.task_desc}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <Popover stopPropagation={["click"]}>
            <Popover.Menu
              trigger="click"
              getContainer={() =>
                document.getElementsByClassName("chat-message-list-content")[0]
              }
              actions={(() => {
                const nowTime = Date.parse(new Date());
                if (nowTime - msg.time < 120000 && flow === "out") {
                  return outAction;
                } else {
                  return is_appoint_intendant ? appointInAction : inAction;
                }
              })()}
              mode="dark"
              placement="top"
              onAction={(action) => onMessageAction(action, msg)}
            >
              <div style={{ maxWidth: "100%" }}>
                <div className="container">
                  {(() => {
                    // 活动
                    if (msg.subType == 1) {
                      return (
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            padding: "10px 15px 15px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            general.game = msg.attach?.game_info;
                            general.history.push(
                              "/article/detail?id=" +
                                msg.attach?.news_id +
                                "&type=activity"
                            );
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              borderBottom: "0.5px solid #E6E6E6",
                              paddingBottom: "10px",
                            }}
                          >
                            <div
                              className="line"
                              style={{
                                backgroundColor: "#6167E0",
                                borderRadius: "3px",
                                color: "white",
                                padding: "0 3px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: "0",
                              }}
                            >
                              活动
                            </div>
                            <div
                              className="text"
                              style={{
                                paddingLeft: "5px",
                                color: "#6167E0",
                                fontSize: "14px",
                                fontWeight: "500",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {msg.attach?.news_title}
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingTop: "15px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="content"
                              style={{
                                overflow: "hidden",
                                paddingRight: "15px",
                              }}
                            >
                              <div
                                className="gamename"
                                style={{
                                  fontSize: "0.32rem",
                                  fontWeight: "500",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  color: "#282828",
                                }}
                              >
                                {msg.attach?.game_info?.game_name}
                                {msg.attach?.game_info?.nameRemark
                                  ? "-" + msg.attach?.game_info?.nameRemark
                                  : ""}
                              </div>
                              <div
                                className="desc"
                                style={{
                                  fontSize: "11px",
                                  color: "#999",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {msg.attach?.new_content}
                              </div>
                            </div>
                            <img
                              height={63}
                              src={msg.attach?.game_info?.game_image?.thumb}
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    }
                    // 攻略
                    if (msg.subType == 2) {
                      return (
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            padding: "10px 15px 15px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            general.game = msg.attach?.game_info;
                            general.history.push(
                              "/article/detail?id=" +
                                msg.attach?.news_id +
                                "&type=raiders"
                            );
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              overflow: "hidden",
                              borderBottom: "0.5px solid #E6E6E6",
                              paddingBottom: "10px",
                            }}
                          >
                            <div
                              className="line"
                              style={{
                                backgroundColor: "#EB475F",
                                borderRadius: "3px",
                                color: "white",
                                padding: "0 3px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: "0",
                              }}
                            >
                              攻略
                            </div>
                            <div
                              className="text"
                              style={{
                                paddingLeft: "5px",
                                color: "#EB475F",
                                fontSize: "14px",
                                fontWeight: "500",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {msg.attach?.news_title}
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingTop: "15px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="content"
                              style={{
                                overflow: "hidden",
                                paddingRight: "15px",
                              }}
                            >
                              <div
                                className="gamename"
                                style={{
                                  fontSize: "0.32rem",
                                  fontWeight: "500",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {msg.attach?.game_info?.game_name}
                                {msg.attach?.game_info?.nameRemark
                                  ? "-" + msg.attach?.game_info?.nameRemark
                                  : ""}
                              </div>
                              <div
                                className="desc"
                                style={{
                                  fontSize: "11px",
                                  color: "#999",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {msg.attach?.new_content}
                              </div>
                            </div>
                            <img
                              height={63}
                              src={msg.attach?.game_info?.game_image?.thumb}
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    }
                    // 交易
                    if (msg.subType == 3) {
                      return (
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            padding: "10px 15px 15px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            general.history.push(
                              "/trade/detail?id=" + msg.attach?.trade_id
                            );
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              borderBottom: "0.5px solid #E6E6E6",
                              paddingBottom: "10px",
                            }}
                          >
                            <div
                              className="line"
                              style={{
                                backgroundColor: "#FF5E00",
                                borderRadius: "3px",
                                color: "white",
                                padding: "0 3px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: "0",
                              }}
                            >
                              交易
                            </div>
                            <div
                              className="text"
                              style={{
                                paddingLeft: "5px",
                                color: "#FF5E00",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              出售角色
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingTop: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="content"
                              style={{
                                overflow: "hidden",
                                paddingRight: "15px",
                              }}
                            >
                              <div
                                className="gamename"
                                style={{
                                  color: "#282828",
                                  fontSize: "0.32rem",
                                  fontWeight: "500",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {msg.attach?.game_info?.game_name}
                                {msg.attach?.game_info?.nameRemark
                                  ? "-" + msg.attach?.game_info?.nameRemark
                                  : ""}
                              </div>
                              <div
                                className="desc"
                                style={{ fontSize: "11px", color: "#999" }}
                              >
                                {msg.attach?.equipment_declare}
                              </div>
                              <div
                                className="price"
                                style={{
                                  color: "#FF5E00",
                                  fontSize: "16px",
                                  fontWeight: "500",
                                }}
                              >
                                ￥{msg.attach?.sell_price}
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#999",
                                    fontSize: "0.22rem",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  ￥{msg.attach?.origin_price}
                                </span>
                              </div>
                            </div>
                            <img
                              height={63}
                              src={msg.attach?.game_info?.game_image?.thumb}
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    }
                    // 社区攻略
                    if (msg.subType == 4) {
                      return (
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            padding: "10px 15px 15px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            general.game = msg.attach?.game_info;
                            general.history.push(
                              "/communityDetail?id=" +
                                msg.attach?.id +
                                "&tagid=" +
                                msg.attach?.tagid +
                                "&circles_type=" +
                                msg.attach?.circles_type +
                                "&topic_id=" +
                                msg.attach?.topic_id
                            );
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              overflow: "hidden",
                              borderBottom: "0.5px solid #E6E6E6",
                              paddingBottom: "10px",
                            }}
                          >
                            <div
                              className="line"
                              style={{
                                backgroundColor: "#EB475F",
                                borderRadius: "3px",
                                color: "white",
                                padding: "0 3px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: "0",
                              }}
                            >
                              攻略
                            </div>
                            <div
                              className="text"
                              style={{
                                paddingLeft: "5px",
                                color: "#EB475F",
                                fontSize: "14px",
                                fontWeight: "500",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {msg.attach?.title}
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingTop: "15px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="content"
                              style={{
                                overflow: "hidden",
                                paddingRight: "15px",
                              }}
                            >
                              <div
                                className="gamename"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {msg.attach?.game_info?.game_name}
                                {msg.attach?.game_info?.nameRemark
                                  ? "-" + msg.attach?.game_info?.nameRemark
                                  : ""}
                              </div>
                              <div
                                className="desc"
                                style={{
                                  fontSize: "11px",
                                  color: "#999",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {msg.attach?.content}
                              </div>
                            </div>
                            <img
                              height={63}
                              src={msg.attach?.game_info?.game_image?.thumb}
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    }
                    // 社区活动
                    if (msg.subType == 5) {
                      return (
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            padding: "10px 15px 15px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            general.game = msg.attach?.game_info;
                            general.history.push(
                              "communityDetail?id=" +
                                msg.attach?.id +
                                "&tagid=" +
                                msg.attach?.tagid +
                                "&circles_type=" +
                                msg.attach?.circles_type +
                                "&topic_id=" +
                                msg.attach?.topic_id
                            );
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              overflow: "hidden",
                              borderBottom: "0.5px solid #E6E6E6",
                              paddingBottom: "10px",
                            }}
                          >
                            <div
                              className="line"
                              style={{
                                backgroundColor: "#6167E0",
                                borderRadius: "3px",
                                color: "white",
                                padding: "0 3px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: "0",
                              }}
                            >
                              活动
                            </div>
                            <div
                              className="text"
                              style={{
                                paddingLeft: "5px",
                                color: "#6167E0",
                                fontSize: "14px",
                                fontWeight: "500",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {msg.attach?.title}
                            </div>
                          </div>
                          <div
                            className="container"
                            style={{
                              paddingTop: "15px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="content"
                              style={{
                                overflow: "hidden",
                                paddingRight: "15px",
                              }}
                            >
                              <div
                                className="gamename"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {msg.attach?.game_info?.game_name}
                                {msg.attach?.game_info?.nameRemark
                                  ? "-" + msg.attach?.game_info?.nameRemark
                                  : ""}
                              </div>
                              <div
                                className="desc"
                                style={{
                                  fontSize: "11px",
                                  color: "#999",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {msg.attach?.content}
                              </div>
                            </div>
                            <img
                              height={63}
                              src={msg.attach?.game_info?.game_image?.thumb}
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    }
                  })()}
                </div>
              </div>
            </Popover.Menu>
          </Popover>
        );
      }
    }
    if (type === "text") {
      let teamText = "";
      let replyText = "";
      if (custom) {
        const yxAitMsg = JSON.parse(custom);
        Object.keys(yxAitMsg).map((key) => {
          const users = yxAitMsg[key];
          Object.keys(users).map((userkey) => {
            const user = users[userkey];
            teamText = user["text"];
          });
        });

        if (yxAitMsg.yxReplyMsg) {
          const replyMsg = store.msgStore.getMsg(
            store.uiStore.selectedSession,
            [yxAitMsg.yxReplyMsg.idClient]
          );
          if (replyMsg.length > 0) {
            replyText = "| " + replyMsg[0].fromNick + ": " + replyMsg[0].text;
          }
        }
      }

      const prefix = "common";
      const _prefix = `${prefix}-parse-session`;
      const { EMOJI_ICON_MAP_CONFIG, INPUT_EMOJI_SYMBOL_REG } =
        handleEmojiTranslate(t);

      let text = reactStringReplace(
        body.replace(teamText, ""),
        /(https?:\/\/\S+)/gi,
        (match, i) => (
          <a key={idClient + match + i} href={match} target="_blank">
            {match}
          </a>
        )
      );
      text = reactStringReplace(text, INPUT_EMOJI_SYMBOL_REG, (match, i) => {
        return (
          <CommonIcon
            key={idClient + match + i}
            className={`${_prefix}-emoji-icon`}
            type={EMOJI_ICON_MAP_CONFIG[match]}
          />
        );
      });
      if (ext) {
        try {
          const extObj = JSON.parse(ext);
          const yxAitMsg = extObj.yxAitMsg;
          if (yxAitMsg && localOptions.needMention) {
            Object.keys(yxAitMsg).forEach((key) => {
              const item = yxAitMsg[key];
              text = reactStringReplace(text, item.text, (match, i) => {
                return (
                  <span
                    key={idClient + match + i}
                    className={`${_prefix}-mention`}
                  >
                    {match}
                  </span>
                );
              });
            });
          }
        } catch {}
      }
      return (
        <>
          <Popover.Menu
            trigger="click"
            getContainer={() =>
              document.getElementsByClassName("chat-message-list-content")[0]
            }
            actions={(() => {
              const nowTime = Date.parse(new Date());
              if (nowTime - msg.time < 120000 && flow === "out") {
                return outAction;
              } else {
                return is_appoint_intendant ? appointInAction : inAction;
              }
            })()}
            mode="dark"
            placement="top"
            onAction={(action) => onMessageAction(action, msg)}
          >
            <div
              className={`${_prefix}-text-wrapper`}
              style={{
                padding: "10px",
                borderRadius: "8px",
                color: "#282828",
                fontSize: ".3rem",
                backgroundColor: msg.flow === "in" ? "white" : "#FDF9ED",
                wordBreak: "break-word",
              }}
            >
              {replyText.length > 0 && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    padding: "5px 0 10px",
                    borderBottom: "0.5px solid #dfdfdf",
                    marginBottom: "10px",
                  }}
                >
                  {replyText}
                </div>
              )}
              <span className={`${_prefix}-mention`}>{teamText}</span>
              {text}
            </div>
          </Popover.Menu>
        </>
      );
    }
  };

  const renderTeamCustomMessage = (msg) => {
    const { attach, type } = msg.msg;
    // console.log("msg", msg);
    if (
      type == "notification" &&
      attach &&
      attach.type == "removeTeamMembers"
    ) {
      return <div></div>;
    }
    if (type == "notification" && attach && attach.type == "leaveTeam") {
      return <div></div>;
    }
    if (type == "notification" && attach && attach.type == "addTeamMembers") {
      return <div></div>;
    }
    if (type == "notification" && attach && attach.type == "updateTeamMute") {
      const account = attach.account;
      const mute = attach.mute;
      if (mute == false) {
        return <div></div>;
      }
      const users = attach.users;
      const user = users.find((item) => item.account === account);
      return (
        <div style={{ textAlign: "center", color: "#999", padding: 10 }}>
          {user.nick + " 被管理员禁言"}
        </div>
      );
    }
    if (type == "custom" && attach && attach.type == "beReCallMsg") {
      return <div></div>;
    }
  };

  const renderMessageName = (msg) => {
    return (
      <div
        style={{ display: "flex", alignItems: "center", paddingBottom: "8px" }}
      >
        <div
          style={{ fontSize: "12px", color: "#666", wordBreak: "break-all" }}
        >
          {nickMembers.filter((e) => e.account == msg.from).length > 0
            ? nickMembers.filter((e) => e.account == msg.from)[0].nickInTeam
            : msg.fromNick}
        </div>
        {members.length > 0 &&
          findAccountFilter(members, msg.from) &&
          findAccountFilter(members, msg.from)?.honor_icon?.length > 0 && (
            <img
              width={24}
              style={{ marginLeft: "5px" }}
              src={findAccountFilter(members, msg.from).honor_icon}
            />
          )}
        {members.length > 0 && !findAccountFilter(members, msg.from) && (
          <img
            width={unInChatInfo[msg.from]?.honor_icon ? 24 : 0}
            style={{ marginLeft: "5px" }}
            src={unInChatInfo[msg.from]?.honor_icon}
          />
        )}
      </div>
    );
  };

  const findAccountFilter = (data, account) => {
    if (account == localStorage.getItem("yx_account") && !is_display_honor) {
      return null;
    }

    // 使用 flatMap() 展开所有嵌套的列表成一个一维数组
    const allItems = data.flatMap((item) => item.list || []);

    // 使用 find() 查找第一个 account 属性匹配的项
    const result = allItems.find((item) => item.account === account);

    if (!result && !unInChatInfo[account]) {
      unInChatInfo[account] = {
        honor_icon: "",
      };
      general.axios
        .post("/getTeamUserDependentData", {
          accid: account,
        })
        .then((res) => {
          const { status, data } = res.data;
          if (status.succeed) {
            unInChatInfo[account] = data;
            console.log("====================================");
            console.log("unInChatInfo", unInChatInfo);
            console.log("====================================");
          }
        });
    }
    // 如果 find() 找到了匹配项，它会返回该对象；否则返回 undefined。
    // 我们将 undefined 转换为 null，以保持返回类型的一致性。
    return result || null;
  };

  const getMembers = () => {
    general.axios
      .post("/base/yunxin/teamListUsers", { tid: props.query.tid })
      .then((res) => {
        const { status, data } = res.data;
        if (status.succeed) {
          members = data;
        }
      });
  };

  useEffect(() => {
    if (props.active) {
      props.setOperate(
        <div>
          <Link to={`/announcement?tid=${props.query.tid}`}>
            <img src="resources/im/gonggao.png" style={{ width: "20px" }} />
          </Link>
          <Link to={`/teamSetting?tid=${props.query.tid}`}>
            <img
              src="resources/im/setting.png"
              style={{ width: "20px", marginLeft: "8px" }}
            />
          </Link>
        </div>
      );
    }
  }, [props.active]);

  useEffect(() => {
    props.setTitle(title);
  }, [title]);

  const getYXNickMembers = () => {
    store.teamMemberStore.getTeamMemberActive(props.query.tid).then((res) => {
      console.log("========", res);

      nickMembers = res;
    });
  };

  const updateMsg = () => {
    console.log("IMChat: updateMsg called");
    store.msgStore
      .getHistoryMsgActive({
        sessionId: `team-${props.query.tid}`,
        limit: 5,
      })
      .then((res) => {});
  };

  // 页面可见性（前台/后台）监听：只关心从后台进入前台，触发 `updateMsg()`
  useEffect(() => {
    const handleVisible = () => {
      console.log(
        "IMChat: visibility change -> visible. props.active=",
        props.active
      );
      // 仅当当前页面处于激活状态时才刷新消息
      if (!props.active) return;
      try {
        updateMsg();
      } catch (e) {}
    };

    const visibilityHandler = () => {
      const hidden =
        typeof document.hidden !== "undefined"
          ? document.hidden
          : typeof document.webkitHidden !== "undefined"
          ? document.webkitHidden
          : false;
      console.log("IMChat: visibilityHandler fired. hidden=", hidden);
      if (!hidden) handleVisible();
    };

    const visibilityEvent =
      typeof document.hidden !== "undefined"
        ? "visibilitychange"
        : typeof document.webkitHidden !== "undefined"
        ? "webkitvisibilitychange"
        : null;

    if (visibilityEvent)
      document.addEventListener(visibilityEvent, visibilityHandler, false);
    else {
      window.addEventListener("focus", handleVisible);
      window.addEventListener("pageshow", handleVisible);
    }

    // Cordova / Hybrid
    if (document.addEventListener) {
      document.addEventListener("resume", handleVisible, false);
    }

    return () => {
      if (visibilityEvent)
        document.removeEventListener(visibilityEvent, visibilityHandler, false);
      else {
        window.removeEventListener("focus", handleVisible);
        window.removeEventListener("pageshow", handleVisible);
      }
      if (document.removeEventListener) {
        document.removeEventListener("resume", handleVisible, false);
      }
    };
  }, [props.active]);

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState();
      if (state.refreshRedEnvelopeData) {
        const data = state.refreshRedEnvelopeData
        const tid = data.tid
        if (tid == props.query.tid) {
          if (data.is_exists) {
            setVisible(false)
          } else {
            setVisible(true)
            setRedenvelopeTopMsg(data)
          }
        }
      }        
    })
  }, []);

  useEffect(() => {
    if (props.active) {
      updateMsg();
      gotoChat();
      getTeamInfo();
      getYXNickMembers();
      getRedenvelopeTopMess(props.query.tid)
      nim.getTeamInfo({
        teamId: props.query.tid,
      }).then(team=>{
        const ext = JSON.parse(team.ext || '{}');
        console.log('team=====',ext);
        if(ext.yxAllowAt == 'all'){
          nim.updateTeamInfo({
            teamId: props.query.tid,
            ext: JSON.stringify({ 'yxAllowAt' : 'manager' }),
          })
        }
      })
      nim.on("msg", (msg) => {
        if (msg.attach) {
          const type = msg.attach.type;
          if (type == "updateTeam" && msg.to == props.query.tid) {
            const { announcement } = msg.attach.team;
            if (announcement) {
              getTeamInfo();
            }
          }
          if (type == "removeTeamMembers" && msg.to == props.query.tid) {
            const accounts = msg.attach.accounts;
            for (const account of accounts) {
              if (account == localStorage.getItem("yx_account")) {
                Dialog.info("您已被踢出群聊", () => {
                  general.history.goBack();
                });
              }
            }
          }
        }
      });
    }
    return () => {
      store.uiStore.selectedSession = undefined;
    };
  }, [props.active]);

  const getRedenvelopeTopMess = (tid) => {
    general.axios.post('/getRedenvelopeTopMess',{
      tid
    }).then(res=>{
      const {status,data} = res.data;
      if(status.succeed){
        if (Object.keys(data).length === 0) {
          setVisible(false)
          return
        }
        setVisible(true)
        setRedenvelopeTopMsg(data)
      }
    })
  }

  const gotoChat = () => {
    const sessionId = `team-${props.query.tid}`;
    store.uiStore.selectSession(sessionId);
    setTimeout(() => {
      store.sessionStore.insertSessionActive("team", props.query.tid, true);
    }, 100);
    store.sessionStore.resetSession(sessionId).then(() => {
      redux.dispatch({
        type: "updateChatUnread",
        data: {
          updateChatUnread: true,
        },
      });
    });
    setTimeout(() => {
      const textarea = document.getElementsByClassName("ant-input")[0];
      if (textarea) {
        textarea.setAttribute("enterkeyhint", "send");
      }
      window.scrollTo(0, document.documentElement.scrollHeight);
    }, 2000);
  };

  const [is_appoint_intendant, setIs_appoint_intendant] = useState(false);
  const getTeamInfo = () => {
    general.axios
      .post("/base/yunxin/getClusterInfo", { tid: props.query.tid })
      .then((res) => {
        const { data, status } = res.data;
        if (status.succeed) {
          setTitle(data.info.tname);
          setAnnouncement(data.info.announcement.list);
          if (data.info.pack_serialcode && data.info.pack_serialcode.length > 0) {
            set_pack_serialcode(data.info.pack_serialcode);
          }
          setGameid(data.info.gameid);
          setIs_appoint_intendant(data.info.is_appoint_intendant);
          set_is_display_honor(data.info.is_display_honor == 0);
          getMembers();
        } else {
          Dialog.error(status.error_desc);
        }
      });
  };

  useEffect(() => {
    if (pack_serialcode.length > 0) {
      setAlert(true);
    }
  }, [pack_serialcode]);

  const handleService = () => {
    general.history.push("/service");
  };

  const handleQuestion = () => {
    general.history.push(`/detailTrade?id=${gameid}`);
  };

  return (
    <div className="chat-index">
      {announcement && announcement.length > 0 ? (
        <div
          className="chat-announcement"
          style={{
            display:
              announcement.length > 0 && announcement[0].is_read === false
                ? ""
                : "none",
          }}
          onClick={() => {
            general.history.push(
              `/announcement?tid=${props.query.tid}&open=true`
            );
          }}
        >
          <img src="resources/im/laba.png" />
          <span className="content">{announcement[0].title}</span>
        </div>
      ) : null}
      <ChatContainer
        renderEmpty={() => null}
        msgOperMenu={[]}
        renderTeamInputPlaceHolder={renderTeamInputPlaceHolder}
        renderHeader={() => null}
        renderMessageOuterContent={renderMessageOuterContent}
        renderTeamCustomMessage={renderTeamCustomMessage}
        renderMessageName={renderMessageName}
      />
      <div className="service">
        <div className="service-container" onClick={handleService}>
          <img src="resources/im/service.png" alt="" />
          <span>联系客服</span>
        </div>
        {gameid && (
          <div className="service-container" onClick={handleQuestion}>
            <img src="resources/250410/trade.png" alt="" />
            <span>账号交易</span>
          </div>
        )}
      </div>
      <CSSTransition in={alert} timeout={250} unmountOnExit={true}>
        <div className="im-pack-alert">
          <div className="im-pack-mask" onClick={() => setAlert(false)} />
          <div className="im-pack-container">
            <div className="title">恭喜获得群聊入群礼包！</div>
            <div className="pack">{pack_serialcode}</div>
            <CopyToClipboard
              text={pack_serialcode}
              onCopy={() => Dialog.info("已复制礼包码，可前往我的礼包查看！")}
            >
              <div
                className="done"
                onClick={() => {
                  setAlert(false);
                }}
              >
                我知道了
              </div>
            </CopyToClipboard>
          </div>
        </div>
      </CSSTransition>
      <RedEnvelopeAlert 
        visible={visible} 
        type='cluster_task_accomplish' 
        goBack={true}
        getContainer={document.getElementsByClassName('chat-index')[0]} 
        attach={redenvelopeTopMsg} 
        handleAction={handleAction}
      ></RedEnvelopeAlert>
    </div>
  );
}
